import { createContext } from 'react';

const paisContext = createContext();

export default paisContext;